import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  inject,
  OnInit,
  AfterViewInit,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

import { LoginService } from '../../services/login.service';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';


interface LoginForm {
  cpf: FormControl;
  password: FormControl;
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ToastModule,
    ButtonModule,
    InputTextModule,
    CardModule,
  ],
  template: `
    <p-toast></p-toast>
    <body id="login">
      <!-- Barra superior laranja -->
      <div class="top-bar"></div>
      
      <header class="header-login">
        <img src="assets/amc-branca.png" alt="Logo AMC" class="logo-login">
      </header>
      
      <div class="container-login">
        <div class="well-pai">
          <div class="rectangle azul-top"></div>
          <div class="rectangle verde-left"></div>
          <div class="rectangle laranja-bottom"></div>
          <div class="well">
            <h1 class="labelNomeSistema">NUCON</h1>
            
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
              <div class="loginCpf">
                <div class="login-input-container">
                  <input
                    #cpfInput
                    type="text"
                    id="cpf"
                    formControlName="cpf"
                    maxlength="14"
                    placeholder="CPF"
                    class="login-input cpf-input"
                    [ngClass]="{ 'error-input': isFieldInvalid('cpf') }"
                    (keydown.enter)="moveToNextField('cpf', 'password')"
                    (input)="formatCpf($event)"
                  />
                  <span class="input-icon cpf-icon">👤</span>
                </div>
              </div>
              
              <div class="loginSenha">
                <div class="login-input-container">
                  <input
                    type="password"
                    id="password"
                    formControlName="password"
                    placeholder="•••••••••"
                    class="login-input senha-input"
                    [ngClass]="{ 'error-input': isFieldInvalid('password') }"
                    (keyup.enter)="onSubmit()"
                  />
                  <span class="input-icon senha-icon">🔒</span>
                </div>
                <div *ngIf="isFieldInvalid('password')" class="error-message">
                  Informe a Senha.
                </div>
              </div>
              
              <div class="checkbox-row">
                <div class="checkbox-group">
                  <input id="chkLembrar" type="checkbox" class="custom-checkbox" />
                  <label for="chkLembrar" class="checkbox-label">Lembrar CPF</label>
                </div>
                <div class="forgot-password">
                  <a href="https://scc.amc.fortaleza.ce.gov.br/login/recuperarsenha.xhtml">Esqueceu a senha?</a>
                </div>
              </div>
              
              <div class="login-button-container">
                <button
                  type="submit"
                  class="login-button"
                  [disabled]="!loginForm.valid"
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      
      <footer class="footer-login">
        <span>Copyright© {{ currentYear }} | <b>AMC</b> - Suporte Técnico: desenvolvimento&#64;amc.fortaleza.ce.gov.br</span>
      </footer>
    </body>
  `,
  styles: [
    `
     /* Reset completo - Remove todos os gaps e espaçamentos */
      :host {
        display: block !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        margin: 0 !important;
        padding: 0 !important;
        background-color: #ffe6cb !important;
        overflow: hidden !important;
      }

      * {
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      html,
      body {
        color: #2c3e50 !important;
        background-color: #ffe6cb !important;
        font-family: 'Montserrat', sans-serif !important;
        height: 100vh !important;
        width: 100vw !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
      }

      /* Remove scrollbars completamente */
      html::-webkit-scrollbar,
      body::-webkit-scrollbar,
      :host::-webkit-scrollbar,
      *::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      /* Força o preenchimento completo - Remove qualquer gap restante */
      app-root {
        display: block !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        margin: 0 !important;
        padding: 0 !important;
        background-color: #ffe6cb !important;
      }

      /* Remove margens padrão de todos os elementos Angular */
      app-login,
      router-outlet {
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      #login {
        background-color: #ffe6cb !important;
        height: 100vh !important;
        width: 100vw !important;
        display: flex !important;
        overflow: hidden !important;
        margin: 0 !important;
        padding: 0 !important;
        flex-direction: column !important;
        justify-content: center !important;
        align-items: center !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
      }

      /* Barra superior laranja */
      .top-bar {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        width: 100vw !important;
        height: 65px !important;
        background-color: #f15a22 !important;
        z-index: 999 !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: translateX(0) !important;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        z-index: 1000;
      }

      /* Header */
      .header-login {
        position: fixed;
        top: 10px;
        right: 20px;
        z-index: 1001;
      }

      .logo-login {
        height: 40px;
        width: auto;
      }

      /* Container principal */
      .container-login {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200vh;
        width: 100%;
      }

      .well-pai {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .well {
        background: white;
        padding: 30px 40px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        width: 450px;
        min-height: 450px;
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      /* Título */
      .labelNomeSistema {
        font-family: 'Open Sans', sans-serif;
        color: #325565;
        font-weight: bolder;
        width: 100%;
        text-align: center;
        font-size: 45px;
        margin: 0 0 35px 0 !important;
        letter-spacing: 1px;
      }

      /* Form container */
      form {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 20px; /* Mantém o espaçamento original */
      }

      /* Inputs */
      .loginCpf,
      .loginSenha {
        margin: 0;
        display: flex;
        justify-content: center;
      }

      .loginSenha {
        position: relative;
        margin: 0;
        display: flex;
        justify-content: center;
        min-height: 50px; /* Altura do input */
      }

      .login-input-container {
        position: relative;
        width: 100%;
        max-width: 350px;
      }

      .login-input {
        width: 100%;
        padding: 15px 50px 15px 20px !important;
        border: none;
        border-radius: 25px;
        font-size: 16px;
        box-sizing: border-box;
        outline: none;
        background-color: #f0f0f0;
        color: #666;
        transition: all 0.3s ease;
        min-height: 50px;
      }

      .login-input::placeholder {
        color: #999;
        font-weight: 400;
      }

      .input-icon {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        color: #dc3545;
        font-size: 14px;
        pointer-events: none;
      }

      .login-input:focus {
        background-color: #e8e8e8;
      }

      .error-input {
        background-color: #f8d7da !important;
        border: 2px solid #dc3545 !important;
      }

      .error-message {
        color: #dc3545;
        font-size: 12px;
        position: absolute;
        bottom: -18px; /* Posiciona logo abaixo do input */
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 350px;
        text-align: left;
        padding-left: 20px;
        box-sizing: border-box;
        background: transparent;
        pointer-events: none;
      }

      /* Checkbox e link row */
      .checkbox-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px auto 0 auto !important; /* Ajuste na margem superior */
        font-size: 14px;
        width: 100%;
        max-width: 350px;
      }

      .checkbox-group {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .custom-checkbox {
        width: 16px;
        height: 16px;
        accent-color: #17a2b8;
      }

      .checkbox-label {
        color: #17a2b8;
        font-weight: 500;
        cursor: pointer;
      }

      .forgot-password a {
        color: #666;
        text-decoration: none;
        font-size: 14px;
      }

      .forgot-password a:hover {
        text-decoration: underline;
      }

      /* Botão Login */
      .login-button-container {
        margin: 0;
        display: flex;
        justify-content: center;
      }

      .login-button {
        width: 100%;
        max-width: 350px;
        padding: 15px 30px;
        background: #f15a22;
        color: white;
        border: none;
        border-radius: 25px;
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 4px 15px rgba(253, 126, 20, 0.3);
        min-height: 54px;
      }

      .login-button:hover {
        background: #f15a22;
        box-shadow: 0 6px 20px rgba(253, 126, 20, 0.4);
        transform: translateY(-2px);
      }

      .login-button:disabled {
        background: #f15a22;
        cursor: not-allowed;
        box-shadow: none;
        transform: none;
      }

      /* Retângulos decorativos - baseados na imagem Guardião */
      .rectangle {
        position: absolute;
        z-index: 1;
      }

      .rectangle.azul-top {
        width: 115px;
        height: 115px;
        background-color: #00a0dc;
        top: -20px;
        right: -20px;
      }

      .rectangle.verde-left {
        width: 50px;
        height: 130px;
        background-color: #009889;
        bottom: -30px;
        left: -30px;
      }

      .rectangle.laranja-bottom {
        width: 130px;
        height: 30px;
        background-color: #fd7e14;
        bottom: -30px;
        left: -30px;
      }

      /* Footer */
      .footer-login {
        background-color: #009889 !important;
        color: white !important;
        text-align: center !important;
        position: fixed !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        width: 100vw !important;
        font-size: 16px !important;
        font-family: 'Montserrat', sans-serif !important;
        height: 33px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: translateX(0) !important;
      }

      /* Form groups */
      .form-group {
        margin-bottom: 15px;
      }

      /* Responsive */
      @media (max-width: 768px) {
        .well {
          width: 90%;
          max-width: 400px;
          padding: 30px 15px;
          min-height: 380px;
        }

        .loginCpf,
        .loginSenha {
          margin: 0 15px 25px 15px;
        }

        .checkbox-row {
          margin: 15px 15px 30px 15px;
        }

        .login-button-container {
          margin: 15px 15px 0 15px;
        }

        .labelNomeSistema {
          margin: 0 15px 30px 15px;
          font-size: 32px;
        }

        .rectangle {
          display: none;
        }

        .header-login {
          top: 10px;
          right: 10px;
        }

        .logo-login {
          height: 40px;
        }

        .footer-login {
          font-size: 14px;
        }
      }
    `,
  ],
  providers: [LoginService],
})
export class LoginComponent implements OnInit, AfterViewInit {
  http = inject(HttpClient);

  currentYear: number = new Date().getFullYear();

  loginForm!: FormGroup<LoginForm>;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      cpf: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/),
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
      ]),
    });
  }

  onSubmit(): void {
    if (this.loginForm.invalid) return;
    if (this.loginForm.valid) {
      //console.log('🔄 Iniciando login...');
      
      // Limpa caracteres especiais do CPF antes de enviar
      const cleanCpf = this.loginForm.value.cpf?.replace(/\D/g, '') || '';
      
      this.loginService
        .login(cleanCpf, this.loginForm.value.password)
        .subscribe({
          next: () => {
            //console.log('✅ Login bem-sucedido, redirecionando para /home');
           // Se tiver a role SUPERUSER direcionar para /home/dashboard, caso contrário direcionar para /home/search 

           if (this.isSuperUser()) {
             this.router.navigateByUrl('/home/complaints');
           } else {
             this.router.navigateByUrl('/home/complaints');
           }

          },
          error: (error: any) => {
            console.error('❌ Erro no login:', error);
            // Show error message using PrimeNG toast
            this.messageService.add({
              severity: 'error',
              summary: 'Erro de Login',
              detail: error.error?.message || 'Credenciais inválidas. Tente novamente.',
              life: 5000
            });
          },
        });
    }
  }

  @ViewChild('cpfInput')
  cpfInputField!: ElementRef;
  ngAfterViewInit() {
    this.cpfInputField.nativeElement.focus();
  }



  formatCpf(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 11) {
      value = value.substring(0, 11);
    }
    
    if (value.length > 9) {
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (value.length > 6) {
      value = value.replace(/(\d{3})(\d{3})(\d+)/, '$1.$2.$3');
    } else if (value.length > 3) {
      value = value.replace(/(\d{3})(\d+)/, '$1.$2');
    }
    
    event.target.value = value;
    this.loginForm.patchValue({ cpf: value });
    
    // Marca o campo como tocado para ativar a validação
    const cpfControl = this.loginForm.get('cpf');
    if (cpfControl) {
      cpfControl.markAsTouched();
      cpfControl.updateValueAndValidity();
    }
  }

  moveToNextField(currentFieldId: string, nextFieldId: string): void {
    const control = this.loginForm.get(currentFieldId);

    if (control) {
      // Marca o campo como tocado para acionar a validação
      control.markAsTouched();
      control.updateValueAndValidity(); // Atualiza a validade após marcar como tocado
    }

    if (this.isFieldInvalid(currentFieldId)) {
      // Se o campo ainda estiver inválido, mantém o foco e exibe o erro
      const currentField = document.getElementById(
        currentFieldId
      ) as HTMLInputElement;
      currentField.focus();
    } else {
      // Se o campo for válido, foca no próximo campo
      const nextField = document.getElementById(nextFieldId) as HTMLElement;
      nextField?.focus();
    }
  }

  isFieldInvalid(field: string): boolean {
    const control = this.loginForm.get(field);
    return !!(control?.invalid && (control.touched || control.dirty));
  }

  isSuperUser(): boolean {
    const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
    return roles.includes('ROLE_SUPERUSER');
  }
}
